import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const { segmentCdnUrl, segmentWriteKey } = publicRuntimeConfig;
export const SEGMENT_CDN_SETTINGS_URL = `${segmentCdnUrl}/v1/projects/${segmentWriteKey}/settings`;
